import * as React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

const StarFilled = createSvgIcon(
  <path d="M12 0 16.2 7.4 24 8.6 18.5 15 20 24 12 18.9 4 24 5.5 15 0 8.6 7.8 7.4 12 0Z" />,
  'StarFilled'
);

export { StarFilled };
